import React from "react";
import { Snackbar, Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import { hideHUD } from "common/src/actions/hudactions";

const AppHUD = () => {
  const dispatch = useDispatch();
  const hud = useSelector((state) => state.huddata);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(hideHUD());
  };

  return (
    <Snackbar
      open={hud.open}
      autoHideDuration={10000} // 10 seconds as requested
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{ mt: 7 }} // Offset from top to not block logo/header
    >
      <Alert
        onClose={handleClose}
        severity={hud.severity || "error"}
        variant="filled"
        sx={{
          width: "100%",
          boxShadow: 3,
          borderRadius: "8px",
          "& .MuiAlert-message": {
            fontSize: "16px",
            fontWeight: 500,
          },
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {hud.msg}
      </Alert>
    </Snackbar>
  );
};

export default AppHUD;
